import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import type { InviteButtonFieldProps } from './invite-button-field.component';
import InviteButtonField from './invite-button-field.component';

interface HfInviteButtonFieldProps extends InviteButtonFieldProps {
  control?: Control;
  name?: string;
}

function HfInviteButtonField({
  id,
  name = 'invite_button',
  control,
  buttonCaption,
  recordId,
  readOnly,
  saveRecord,
  updateLastChangeValue,
  setFormButtonsState,
}: HfInviteButtonFieldProps) {
  return (
    <Controller
      name={name}
      control={control}
      render={() => (
        <InviteButtonField
          id={id}
          buttonCaption={buttonCaption}
          recordId={recordId}
          readOnly={readOnly}
          saveRecord={saveRecord}
          updateLastChangeValue={updateLastChangeValue}
          setFormButtonsState={setFormButtonsState}
        />
      )}
    />
  );
}

export default HfInviteButtonField;
